import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipuriAmenziComponent } from './tipuri-amenzi.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditTipuriAmenziComponent } from './edit-tipuri-amenzi/edit-tipuri-amenzi.component';

@NgModule({
  declarations: [TipuriAmenziComponent, EditTipuriAmenziComponent],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
  exports: [TipuriAmenziComponent],
})
export class TipuriAmenziModule {}
